
$(document).ready( function(){
	if ($('.mobile-menu-trigger').length > 0){
	    $('.mobile-menu-trigger').click( function(){
	    	$(this).toggleClass('open');
	        $('.main-menu').slideToggle();
	    });
	}
});



//////////////////
// WEBPACK FOOTER
// ./app/js/components/navigation.js
// module id = 1
// module chunks = 0